$(document).ready(function () {
    $('input[type=file]').wrap("<div class='file-upload Button Red Tall'></div>");
    $('.file-upload').prepend("Upload receipt");
    $.each($('input[type=file]'), function () {
        $(this).data('uploadStatus', $('<div />').addClass('file-upload-status').text(''));
        $(this).parent().after($(this).data('uploadStatus'));

        $(this).change(function (e) {
            var uploadStatus = $(this).data('uploadStatus');

            if ($(this).val()) {
                var value = $(this).val().split('\\').pop();

                $(uploadStatus).html(value);

                if (e)
                    $(uploadStatus).fadeIn(500);
                else
                    $(uploadStatus).show();
            }
            else if (uploadStatus && uploadStatus.parent()) {
                $(uploadStatus).html("");
                $(uploadStatus).hide();
            }
        });

        $(this).change();
    });
});